var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFromWarehouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 86,
    viewBox: "0 0 89 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 15C27.9999 23.1135 18.9991 31.5635 15.9766 34.1733C15.695 34.385 15.3522 34.4995 15 34.4995C14.6477 34.4995 14.3049 34.385 14.0233 34.1733C11.0008 31.5635 2 23.1135 2 15C2 11.5521 3.36963 8.24556 5.8076 5.8076C8.24556 3.36963 11.5521 2 15 2C18.4478 2 21.7543 3.36963 24.1923 5.8076C26.6303 8.24556 27.9999 11.5521 27.9999 15Z",
    fill: "white",
    stroke: "#5D5FEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9765 19.875C17.6689 19.875 19.8515 17.6924 19.8515 15C19.8515 12.3076 17.6689 10.125 14.9765 10.125C12.2842 10.125 10.1016 12.3076 10.1016 15C10.1016 17.6924 12.2842 19.875 14.9765 19.875Z",
    fill: "#5D5FEF",
    fillOpacity: 0.1,
    stroke: "#5D5FEF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.75 78.875V52.75C74.75 52.1201 74.4998 51.516 74.0544 51.0706C73.609 50.6252 73.0049 50.375 72.375 50.375H48.625C47.9951 50.375 47.391 50.6252 46.9456 51.0706C46.5002 51.516 46.25 52.1201 46.25 52.75V78.875",
    stroke: "#5D5FEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2578 74.1259C84.2578 75.3857 83.7574 76.5939 82.8666 77.4847C81.9758 78.3755 80.7676 78.8759 79.5078 78.8759H41.5078C40.248 78.8759 39.0399 78.3755 38.1491 77.4847C37.2583 76.5939 36.7578 75.3857 36.7578 74.1259V48.0009C36.7573 47.1064 37.0093 46.23 37.485 45.4724C37.9606 44.7149 38.6405 44.107 39.4463 43.7188L58.3276 34.2805C59.0019 33.9319 59.7499 33.75 60.509 33.75C61.2681 33.75 62.0161 33.9319 62.6904 34.2805L81.5669 43.7188C82.3732 44.1067 83.0536 44.7144 83.5297 45.472C84.0057 46.2295 84.2581 47.1062 84.2578 48.0009V74.1259Z",
    fill: "#5D5FEF",
    fillOpacity: 0.1,
    stroke: "#5D5FEF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 60.3438H74.75",
    stroke: "#5D5FEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 70.3281H74.75",
    stroke: "#5D5FEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 39.5V55.0479C14.5 57.5067 16.4933 59.5 18.9521 59.5H29",
    stroke: "#5D5FEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromWarehouse);
export default __webpack_public_path__ + "static/media/fromWarehouse.113b225fdc5ba6fe8f404ce8f9150e20.svg";
export { ForwardRef as ReactComponent };